document.addEventListener('DOMContentLoaded', function() {
  // Swiper initialization for product pair
  const el = document.querySelector('.product_pair-with-swiper');
  if (el) {
    const swiper = new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      loop: false,
      navigation: {
        nextEl: '.product_pair-with-wrapper .swiper-button-next',
        prevEl: '.product_pair-with-wrapper .swiper-button-prev',
      },
    });
  }


  // Toggle functionality for view-full-ingredients
  const toggleElement = document.querySelector('.view-full-ingredients');
  const subItem = document.querySelector('.essano-active-ingredients__item-sub');
  
  if (toggleElement && subItem) {
    toggleElement.addEventListener('click', function(e) {
      e.preventDefault();
      
      const arrow = toggleElement.querySelector('svg');
      const isVisible = subItem.style.display !== 'none' && subItem.offsetHeight > 0;
      
      if (isVisible) {
        // Hide with slide up animation
        subItem.style.transition = 'max-height 0.3s ease-out, opacity 0.3s ease-out';
        subItem.style.maxHeight = subItem.scrollHeight + 'px';
        subItem.style.opacity = '1';
        
        // Force reflow
        subItem.offsetHeight;
        
        subItem.style.maxHeight = '0px';
        subItem.style.opacity = '0';
        
        // Remove active class
        toggleElement.classList.remove('active');
        
        setTimeout(() => {
          subItem.style.display = 'none';
          subItem.style.maxHeight = '';
          subItem.style.opacity = '';
          subItem.style.transition = '';
        }, 300);
      } else {
        // Show with slide down animation
        subItem.style.display = 'block';
        subItem.style.maxHeight = '0px';
        subItem.style.opacity = '0';
        subItem.style.transition = 'max-height 0.3s ease-out, opacity 0.3s ease-out';
        
        // Force reflow
        subItem.offsetHeight;
        
        subItem.style.maxHeight = subItem.scrollHeight + 'px';
        subItem.style.opacity = '1';
        
        // Add active class
        toggleElement.classList.add('active');
        
        setTimeout(() => {
          subItem.style.maxHeight = '';
          subItem.style.transition = '';
        }, 300);
      }
    });
  }

});

